import store from '@/plugins/store';
import types from '@/constants/types';

export default {
    async updateUser(user) {
        await store.dispatch({
            type: types.UPDATE_USER,
            user
        })
    },
    async updateZP(points) {
        await store.dispatch({
            type: types.UPDATE_ZP,
            points
        })
    },
    async updateUserRestrictions(restrictions) {
        await store.dispatch({
            type: types.UPDATE_USER_RESTRICTIONS,
            restrictions
        })
    },
    async updateConfig(config) {
        await store.dispatch({
            type: types.UPDATE_CONFIG,
            config
        })
    },
    updateTotalInGameOnline(data) {
        store.dispatch({
            type: types.UPDATE_TOTAL_IN_GAME_ONLINE,
            payload: data,
        })
    },
    updateNotifications(notifications) {
        store.dispatch({
            type: types.UPDATE_NOTIFICATIONS,
            notifications
        });
    },
    updateComponentVisibility(payload) {
        store.dispatch(types.UPDATE_COMPONENT_VISIBILITY, payload);
    }
}
